import { createContext, ComponentChildren } from 'preact'
import { useCallback, useContext } from 'preact/hooks'

export const TranslationContext = createContext<{ [key: string]: string }>(null)

export function TranslationProvider({
  definitions,
  children
}: {
  definitions: { [key: string]: string }
  children: ComponentChildren
}) {
  return <TranslationContext.Provider value={definitions}>{children}</TranslationContext.Provider>
}

export function useTranslation() {
  const translation = useContext(TranslationContext)
  return useCallback(
    (key: string, replacements?: { [key: string]: string | number }) => {
      let value = translation[key]
      if (!value) return key
      if (replacements) {
        Object.entries(replacements).forEach(([k, v]) => {
          // Replace all occurrences of {key} with the value
          value = value.replace(new RegExp(`{${k}}`, 'g'), String(v))
        })
      }
      return value
    },
    [translation]
  )
}
